import React from "react";
import { useMediaQuery } from "@material-ui/core";


const SortableHeader = ({ title, sortState, onSortChange, mobileResolution, actions }) => {
    // const mobileResolution = useMediaQuery("(max-width:720px)");
    const stylesSpanCellHeader = {
        color: "#3B444D",
        fontSize: "15px",
        padding: 10,
        fontWeight: "700",
        fontFamily: "Quicksand",
        display: 'flex',
        paddingBottom: '20px'
    };

    if (actions) stylesSpanCellHeader.justifyContent = 'center'

    const stylesIconCellHeader = {
        marginLeft: "4px",
    };

    let iconFilter = "k-i-arrows-swap";

    if (sortState === 1) {
        iconFilter = "k-i-sort-asc-sm";
    } else if (sortState === 2) {
        iconFilter = "k-i-sort-desc-sm";
    }

    return (
        <span style={stylesSpanCellHeader} onClick={onSortChange}>
            {title}
            {title === "Fecha límite" || title === "Fecha de alta"
                ? <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i> : ("")}
        </span>
    );
};

export default SortableHeader;
